import { store } from '@/store';
import router from '@/router';
import payment from '@/utils/payment';

const esunwallet =  {
    isESShell: (typeof ESWalletBridge !== 'undefined') || ((typeof global.webkit !== 'undefined') && (typeof global.webkit.messageHandlers.ESWalletBridge !== 'undefined')),
    isIosWebView: (typeof global.webkit !== 'undefined') && (typeof global.webkit.messageHandlers.ESWalletBridge !== 'undefined'),
    fillHUID: function (msg) {
        try {
            if(!store.state.esunwallet.huid){
                store.commit('esunwallet/setHuid', JSON.parse(msg).huid);
            }
            this.GetToken();
        } catch (e) {
            store.commit('setDialog', {
                text: '無法識別您的手機裝置，請稍後再試。' + e.message,
                active: true
            });
            store.commit('closeLoading');
        }
    },
    fillToken: function (msg) {
        try {
            if(!store.state.esunwallet.token){
                store.commit('esunwallet/setToken', JSON.parse(msg).token);
            }
        } catch (e) {
            store.commit('setDialog', {
                text: '無法識別您的資料，請稍後再試。' + e.message,
                active: true
            });
            store.commit('closeLoading');
        }                
    },
    filliData: function (msg) {
        try {
            let jObj = JSON.parse(msg);
            if (jObj['RC'] === '00') {
                store.commit('esunwallet/setiData', jObj.iData);
                let requestData = {
                    TradeData: {
                        //險別
                        InsCategory: router.currentRoute.value.params.type === 'car'? 'Car' : 'Motorcycle',
                        //報價單號
                        EstimateId: store.state.estimate.EstimateId,
                        //金額
                        Amount: store.state.policy.salePrice,
                        //繳費方式
                        PayWay: store.state.policy.payWay*1,
                        //其他資料
                        PropertiesDict: {
                            txToken: store.state.esunwallet.txToken,
                            huid: store.state.esunwallet.huid,
                            iData: store.state.esunwallet.iData,
                            cid: store.state.esunwallet.cid,
                            Holder: store.state.esunwallet.cardHolder
                        }
                    }
                };
                payment.carPayment(requestData);
            }
            else {
                store.commit('setDialog', {
                    text: '目前因系統忙碌或網路連線不穩定，暫時無法完成繳費，請稍後再試。' + jObj['RC'],
                    active: true
                });
                store.commit('closeLoading');
            }
        } catch (e) {
            store.commit('setDialog', {
                text: '目前因系統忙碌或網路連線不穩定，暫時無法完成繳費，請稍後再試。' + e.message,
                active: true
            });
            store.commit('closeLoading');
        }
    },
    GetHUID: function () {                
        var message = '{"version": "1.0","code": "01","callbackFunctionId": "EsunWallet.fillHUID"}';
        try {                    
            if (this.isIosWebView) {
                window.webkit.messageHandlers.ESWalletBridge.postMessage(message);
            }
            else {
                ESWalletBridge.sendMessage(message);
            }
        } catch (e) {
            store.commit('setDialog', {
                text: '無法識別您的手機裝置，請稍後再試。',
                active: true
            });
            store.commit('closeLoading');
        }
    },           
    GetToken: function () {
        try {
            var message = '{"version": "1.0","code": "12","callbackFunctionId": "EsunWallet.fillToken"}';
            var msgObj = JSON.parse(message);
            msgObj['huid'] = store.state.esunwallet.huid;
            if (this.isIosWebView) {
                window.webkit.messageHandlers.ESWalletBridge.postMessage(JSON.stringify(msgObj));
            }
            else {
                ESWalletBridge.sendMessage(JSON.stringify(msgObj));
            }
        } catch (e) {
            store.commit('setDialog', {
                text: '無法識別您的資料，請稍後再試。' + e.message,
                active: true
            });
            store.commit('closeLoading');
        }
    },
    GetLKey: function (amount, txtToken , huid) {
        try {
            var message = '{"version": "1.0","code": "11","callbackFunctionId": "EsunWallet.filliData"}';
            var msgObj = JSON.parse(message);                    
            msgObj['txToken'] = txtToken;
            msgObj['amount'] = amount;                    
            msgObj['huid'] = huid;

            if (typeof msgObj['huid'] === 'undefined') {
                store.commit('setDialog', {
                    text: 'object huid is undefined: ',
                    active: true
                });
            }

            if (this.isIosWebView) {                        
                window.webkit.messageHandlers.ESWalletBridge.postMessage(JSON.stringify(msgObj));                                              
            }
            else {
                ESWalletBridge.sendMessage(JSON.stringify(msgObj));
            }
        } catch (e) {
            store.commit('setDialog', {
                text: '取得信用卡資料時發生錯誤，請稍後再試。' + e.message,
                active: true
            });
            store.commit('closeLoading');
        }
    }
};
  
  export default esunwallet;
  